import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CmsService } from 'src/app/modules/cms/services/cms.service';

@Component({
  selector: 'c-page',
  templateUrl: './c-page.component.html',
  styleUrls: ['./c-page.component.scss']
})
export class CPageComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<boolean> = new Subject();

  @Input() page: any;

  public isLoaded: boolean = false;


  constructor(
    private _cmsService: CmsService
  ) { }

  ngOnInit(): void {
    const isLanding = window.location.pathname.toLowerCase().includes("/landing");
    if (isLanding) this.isLoaded = true;
    this._cmsService.siteMap$.pipe(takeUntil(this._destroy$)).subscribe( pages => {
      if (pages) {
        this.isLoaded = true;
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

}
